<template>
  <div>
    <div class="images" v-if="imageList.length" @click.prevent.stop>
      <viewer :images="imageList">
        <img v-for="src in imageList" :key="src" :src="src" />
      </viewer>
      <div class="add" v-if="imageList.length > 3">+{{ imageList.length - 3 }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Images',
  data() {
    return {
        imageList: []
    }
  },
  created() {
      console.log(this.$route.query.imageList)
      this.imageList = this.$route.query.imageList
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.images {
      position: relative;
      display: flex;
      // justify-content: space-evenly;
      margin-top: 18px;
      img {
        width: 194px;
        height: 118px;
        margin-right: 14px;
        object-fit: contain;
      }
      .add {
        position: absolute;
        left: 624px;
        width: 194px;
        text-align: center;
        color: #fff;
        line-height: 118px;
        font-size: 24px;
        background-color: rgba(0, 0, 0, 0.76);
        border-radius: 5px;
      }
    }
</style>
